import type { SourceSnippet } from '@/types/source-snippet'
import { apiClient } from './client'

export interface EvidenceInput {
  alias?: string
  table: string
  table_id: string
  document_id: string
  filename: string
  source_sha256: string
  parser_version: number
  interpretation: { status: string; recipe: Record<string, unknown> | null; sha256: string | null }
}

export interface EvidenceResult {
  column_lineage?: Record<string, { table: string; column: string }>
  columns: string[]
  rows: Record<string, unknown>[]
  total_rows: number
  count: number
  offset: number
  truncated: boolean
  execution_complete: boolean
  parsing: Array<{
    column: string
    alias: string
    kind: string
    input_rows: number
    null_rows: number
    invalid_rows: number
    interpretation_status: string
  }>
  coverage: { complete: boolean; searched: string[]; requested_scope: string }
  engine: string
}

export interface CaseEvidence {
  kind: 'rows' | 'query_result'
  evidence_reference_id: string
  inputs: EvidenceInput[]
  specification: Record<string, unknown>
  result: EvidenceResult
  verified: boolean
  persistence?: 'preview' | 'saved'
  snippet?: SourceSnippet
}

export function prepareSourceSnippet(caseId: string, snippet: SourceSnippet) {
  return apiClient.post<SourceSnippet>(`/v1/cases/${caseId}/evidence/snippet-preview`, {
    snapshot: snippet.snapshot,
    receipt: snippet.receipt,
    bindings: snippet.bindings,
    title: snippet.title,
  })
}

export function getCaseEvidence(caseId: string, referenceId: string, signal?: AbortSignal) {
  return apiClient.get<CaseEvidence>(`/v1/cases/${caseId}/evidence/${referenceId}`, { signal })
}
